import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SingleSelectComponent } from './components/single-select/single-select.component';
import { SingleSelectDropdownComponent } from './components/single-select-dropdown/single-select-dropdown.component';
import { OpenEndComponent } from './components/open-end/open-end.component';
import { SplashComponent } from './components/splash/splash.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { SurvayComponent } from './components/survay/survay.component';
import { SurvayHeaderComponent } from './components/survay-header/survay-header.component';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { BrowseSurveyModule } from './modules/browse-survey/browse-survey.module';
import { FilterlistPipe } from './components/single-select-dropdown/pipe/filterlist.pipe';
import { MultiSelectComponent } from './components/multi-select/multi-select.component';
import { CounterTypeComponent } from './components/counter-type/counter-type.component';
import { GridTypeComponent } from './components/grid-type/grid-type.component';
import { MultipleChoiceSingleComponent } from './components/multiple-choice-single/multiple-choice-single.component';
import { MultipleChoiceMultipleSelectComponent } from './components/multiple-choice-multiple-select/multiple-choice-multiple-select.component';
import { ErrorModule } from './modules/error/error.module';


const customNotifierOptions: NotifierOptions = {
  position: {
		horizontal: {
			position: 'right',
			distance: 12
		},
		vertical: {
			position: 'bottom',
			distance: 12,
			gap: 10
		}
	},
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 1
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
    AppComponent,
    SingleSelectComponent,
    SingleSelectDropdownComponent,
    OpenEndComponent,
    SplashComponent,
    ThankYouComponent,
    SurvayComponent,
    SurvayHeaderComponent,
    FilterlistPipe,
    MultiSelectComponent,
    CounterTypeComponent,
    GridTypeComponent,
    MultipleChoiceSingleComponent,
    MultipleChoiceMultipleSelectComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    HttpClientModule,
    NotifierModule.withConfig(customNotifierOptions),
    BrowseSurveyModule,
    ErrorModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
